import { Card, Heading, Inline, RadioGroup, Stack, vars } from '@etg/wings';
import { useProperty, useTranslation } from '@eti/providers';
import type { ReactNode } from 'react';
import { constants } from '@eti/utils';
import { cancelForAnyReason, flexibleTicket } from '@eti/products';
import { css } from '@eti/styles';
import type { TicketType } from '../../../model';
import { TicketReadMore } from '../../common/TicketReadMore';
import { ticketErrorId } from '../../../constants';
import { screenReadersOnlyStyles } from '../../../../../../../../utils/styleUtils';

const inlineStyles = css`
  color: ${vars.colors.signal.critical.foreground};
`;

const readmoreLinkStyles = css`
  margin-top: 8px;
`;

interface RadioTicketsProps {
  children: ReactNode;
  hasError: boolean;
  onSelect: (ticketType: TicketType) => void;
  selectedTicketType?: TicketType;
}

const { SEARCH_RESULT_FLEX_BEHAVIOR_OPTIONS } = constants;
const { AIR_REBOOKING } = SEARCH_RESULT_FLEX_BEHAVIOR_OPTIONS;

export const RadioTickets = ({
  children,
  hasError,
  selectedTicketType,
  onSelect,
}: RadioTicketsProps) => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const handleChange = (e: any) => {
    onSelect(e.target.value);
  };
  const ticketVersion = p('Result.Page.Ticket.Version');
  const flexBehaviour = p('IbeClient.SearchResult.Flex.Behaviour');
  const ticketId = flexBehaviour === AIR_REBOOKING ? flexibleTicket.id : cancelForAnyReason.id;
  return (
    <Card>
      <Stack spacing={8}>
        <Heading level={3}>{t('Result.Page.SelectTicketType.Text')}</Heading>
        {hasError && (
          <Inline className={inlineStyles} id="select-ticket-type-validation-error" tabIndex={-1}>
            {t('Result.Page.SelectTicketType.Validation.Text')}
          </Inline>
        )}
        <RadioGroup
          as="div"
          errorId={ticketErrorId}
          hasError={hasError}
          name={`radio-tickets-version-${ticketVersion}`}
          onChange={handleChange}
          selectedValue={selectedTicketType}
        >
          <RadioGroup.Legend className={screenReadersOnlyStyles}>
            {t('Result.Page.SelectTicketType.Text')}
          </RadioGroup.Legend>
          {children}
        </RadioGroup>
        <TicketReadMore className={readmoreLinkStyles} ticketId={ticketId} />
      </Stack>
    </Card>
  );
};
